import React from 'react';
import { Filter, TextInput } from 'react-admin';

const PromoFilters = props => (
  <Filter {...props}>
    <TextInput label="ID" source="id" />
    <TextInput label="Code" source="code" />
    <TextInput label="Amount" source="amount" />
  </Filter>
);

export default PromoFilters;



// WEBPACK FOOTER //
// ./src/resources/promos/PromoFilters.jsx